"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const _ = require("lodash");
function addContent(insertObj) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const contentRef = app_1.app.firestore.collection(`content`);
            if (_.isArray(insertObj)) {
                const chunksOf450 = yield _.chunk(insertObj, 450);
                for (const singleChunk of chunksOf450) {
                    // Get a new write batch
                    const batch = app_1.app.firestore.batch();
                    for (const obj of singleChunk) {
                        const tempRef = contentRef.doc(obj.uid);
                        batch.set(tempRef, obj);
                    }
                    // Commit the batch
                    yield batch.commit();
                }
                return {
                    message: 'All objects written to database successfully'
                };
            }
            else {
                // throw error if variable insertObj doesn't contain key uid
                if (!insertObj.uid) {
                    console.log('insertObj : ', insertObj);
                    throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, `Provided json object doesn't contain field uid`);
                }
                else {
                    yield contentRef.doc(insertObj.uid).set(insertObj);
                    console.log('Document added successfully..', insertObj.uid);
                    return {
                        message: `Single document added successfully with uid: ${insertObj.uid}`
                    };
                }
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addContent;
//# sourceMappingURL=addContent.js.map